export const LEGAL_LINKS = {
  GIFT_CARDS: 'https://www.shipt.com/legal/giftcards',
  TERMS_OF_SERVICE: 'https://www.shipt.com/legal/terms-of-service',
  TEXT_MESSAGE_TERMS: 'https://www.shipt.com/legal/text-message-terms',
  PRIVACY_POLICY: 'https://www.shipt.com/legal/privacy-policy',
  WA_PRIVACY_RIGHTS: 'https://www.shipt.com/legal/health-data-privacy-policy',
}

const PRIVACY_CENTER_URL = 'https://privacy.shipt.com/policies'

/**
 * Privacy links that are swapped when the `transcend_privacy_updates` feature
 * flag is enabled. When the flag is ON, links point to the Transcend privacy
 * center; when OFF, they use the legacy shipt.com legal pages.
 *
 * Use the `usePrivacyLinks` hook to resolve these based on the feature flag
 * rather than referencing either map directly.
 */
export const LEGACY_PRIVACY_LINKS = {
  privacyNotice: LEGAL_LINKS.PRIVACY_POLICY,
  healthDataPrivacy: LEGAL_LINKS.WA_PRIVACY_RIGHTS,
  yourPrivacyChoices: 'https://www.shipt.com/privacy/intake-form',
} as const

export const TRANSCEND_PRIVACY_LINKS = {
  privacyNotice: `${PRIVACY_CENTER_URL}?name=shipt-privacy-notice`,
  healthDataPrivacy: `${PRIVACY_CENTER_URL}?name=health-data-privacy-notice`,
  yourPrivacyChoices: `${PRIVACY_CENTER_URL}?modal=select-subject`,
} as const

export type PrivacyLinks = {
  privacyNotice: string
  healthDataPrivacy: string
  yourPrivacyChoices: string
}
